import { Component, Listen, Prop, State, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../LabelProviderInterface';

@Component({
  tag: 'uiaas-search-widget-conversational-search-overlay',
  styleUrl: 'conversational-search-overlay.scss',
  shadow: true,
})
export class WidgetConversationalSearchOverlay {
  @Prop() readonly labelProvider: labelProviderInterface;

  @State() isModalVisible = false;

  @Listen('conversational-search:terms-and-conditions-modal', {
    target: 'window',
  })
  handleModalTrigger(e: CustomEvent<{ isModalVisible: boolean }>) {
      this.isModalVisible = e.detail.isModalVisible;
  }

  render() {
      return this.isModalVisible ? (
        <section>
          <div class="conversational-search-overlay" onClick={() => this.isModalVisible = false} />
          <uiaas-search-widget-conversational-search-terms-and-conditions-modal labelProvider={(e, f) => this.labelProvider(e, f)} />
        </section>
      ) : (
        ''
      );
  }
}
